<template>
  <data-table
    :columns="columns"
    fieldName="leads"
    :variables="filters"
    :query="query"
    :onClickHandler="onClickLead"
    :rowClickable="!!$router.canSee(['leads.find'])"
  >
    <div slot="filter" class="filter-controls pull-right">
      <slot name="filter"></slot>
    </div>
    <span slot="id" slot-scope="props">
      <router-link @click.stop :to="{ name: 'LeadDetails', params: { id: props.row.id } }">
        {{ props.row.id }}
      </router-link>
    </span>
    <span slot="campaignName" slot-scope="props">
      <span v-if="isWhiteLabel">{{ props.row.campaignName }}</span>
      <router-link v-else :to="{ name: 'CampaignDetails', params: { id: props.row.campaignId } }">
        {{ props.row.campaignName }}
      </router-link>
    </span>
    <span slot="created" slot-scope="props">
      {{ props.row.created | moment("MMM Do YYYY, h:mm:ss a") }}
    </span>
    <span slot="completed" slot-scope="props">
      <i class="mdi mdi-check text-success" v-if="props.row.completed"></i>
    </span>
    <span slot="names" slot-scope="props" v-if="props.row.names">
      {{ props.row.names.join(", ") }}
    </span>
    <span slot="phones" slot-scope="props" v-if="props.row.phones">
      {{ props.row.phones.join(", ") }}
    </span>
    <span slot="emails" slot-scope="props" v-if="props.row.emails">
      {{ props.row.emails.join(", ") }}
    </span>
    <span slot="actions" slot-scope="props">
      <div @click.stop>
        <router-link @click.stop :to="{ name: 'LeadDetails', params: { id: props.row.id } }">
          <i class="mdi mdi-file-outline text-inverse m-r-10"></i>
        </router-link>
      </div>
    </span>
  </data-table>
</template>
<script>
  import { mapGetters } from 'vuex';
import DataTable from '@/components/DataTable';
import { array } from '@/helpers/stdlib';

const DEFAULT_COLUMNS = [
  { field: 'completed', title: ''},
  { field: 'id', title: 'Lead ID' },
  { field: 'created', title: 'Created At' },
  { field: 'campaignName', title: 'Campaign' },
  { field: 'data.stats.numberOfQuestionsAnswered', title: 'A#', skipSorting: true },
  { field: 'names', title: 'Name' },
  { field: 'phones', title: 'Phone' },
  { field: 'emails', title: 'Email' },
  // { field: 'data.stats.numberOfQuestions', title: '#TQs' },
  // { field: 'data.stats.numberOfMandatoryQuestions', title: '#MQs' },
  { field: 'notes', title: 'Notes', skipSorting: true  },
  // { field: 'actions', title: '', skipSorting: true },
];

export default {
  components: {
    DataTable,
  },
  props: {
    role: {
      type: String,
      validator: str => ['administrator', 'client'].includes(str),
      required: true,
    },
    query: Object,
    onClickLead: Function,
    filters: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters(['isWhiteLabel']),
    columns() {
      if (this.role === 'admin') {
        return array.compute(
          array.withElementAt(2, { field: 'companyName', title: 'Company' }),
        )(DEFAULT_COLUMNS);
      }
      return DEFAULT_COLUMNS;
    },
  },
  isClient() {
    return this.role === 'client';
  },
};
</script>



// WEBPACK FOOTER //
// src/components/LeadGrid.vue